<h2 class="content-block"><i class="fa fa-dashboard"></i>Yönetim Paneli</h2>
<div class="container">
  <!--top kısmı -->
  <div class="row top">
    <div class="col-12 col-md-4">
      <div class="content-block">
        <app-card
        icon="return.png"
          title="Toplam Başarılı Vize Sayısı"
          [count]="totalSuccessVisaCount"
          
        ></app-card>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="content-block">
        <app-card
          title="Toplam Alınan Ödeme"
         [count]="('$' + (totalPaymentAmount | number:'1.2-2'))"
          icon="call.png"
        ></app-card>
      </div>
    </div>
    
  </div>
  <!-- Middle  kısmı -->
  <div class="row middle mt-5">

    <!-- Birinci Chart -->
    <div class="col-md-6">
      <div id="chart-demo">
        <dx-chart 
          id="chart1"
          [dataSource]="applicationCountsByDay"
          [title]="title"
          palette="Harmony Light"
        >
          <dxi-value-axis>
            <dxo-label>
              <dxo-format type="decimal"></dxo-format>
            </dxo-label>
          </dxi-value-axis>
  
          <dxo-argument-axis>
            <dxo-label overlappingBehavior="stagger"></dxo-label>
          </dxo-argument-axis>
  
          <dxo-tooltip [enabled]="true" [shared]="true"></dxo-tooltip>
  
          <dxo-common-series-settings argumentField="date"></dxo-common-series-settings>
  
          <dxi-series
            type="line"
            valueField="count"
            name="Başvuru Sayısı"
            color="red"
          >
          </dxi-series>
  
          <dxo-legend verticalAlignment="top" horizontalAlignment="center"></dxo-legend>
        </dx-chart>
      </div>
    </div>
  
    <!-- İkinci Chart -->
    <div class="col-md-6">
      <div>
        <dx-chart
          id="chart2"
          [dataSource]="topCountries"
          palette="Harmony Light"
          title="Ülkelere Göre Başvuru Adedi"
        >
          <dxi-value-axis>
            <dxo-label>
              <dxo-format type="decimal"></dxo-format>
            </dxo-label>
          </dxi-value-axis>
  
          <dxo-argument-axis>
            <dxo-label overlappingBehavior="stagger"></dxo-label>
          </dxo-argument-axis>
  
          <dxi-series
            argumentField="countryName"
            valueField="count"
            name="Sorgu Sayıları"
            type="bar"
            color="lightgrey"
          >
          </dxi-series>
  
          <dxo-tooltip [enabled]="true" [shared]="true"></dxo-tooltip>
  
          <dxo-legend verticalAlignment="top" horizontalAlignment="center"></dxo-legend>
        </dx-chart>
      </div>
    </div>
  
  </div>
  
  <!-- Bottom   kısmı -->
  <div class="row mt-5">
    <!-- son 10 sorgu -->
    <div class="browser-report">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">Son 10 Başvuru</h3>
        <div class="ml-auto">
          <button class="btn btn-primary" (click)="onViewAllApplications()">
            Tüm Başvurular
          </button>
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>Başvuru Numarası</th>
            <th>Başvuru Tarihi</th>
            <th>Ad</th>
            <th>Soyad</th>
            <th>Ülke</th>
            <th>Ödeme Durumu</th>
            <th>Vize Durumu</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of visaApplications">
            <td>
              {{ item.applicationNumber }}
            </td>
            <td>{{ item.visaApplicationDate | date: 'dd.MM.yyyy' }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.surname }}</td>
            <td>{{ item.country }}</td>
            <td [ngClass]="getPaymentStatusClass(item.paymentStatusId)">{{ item.paymentStatus }}</td>
            <td [ngClass]="getVisaStatusClassByText(item.visaStatusId)">{{ getVisaStatusLabel(item.visaStatusId) }}</td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
